import { toast } from "react-toastify";
import axios from "axios";
import { tokenKeyName } from "../config";
import { pages } from "../constants";

//Need to seriously revise this
const handleApiError = (
  ex,
  history,
  fileRequest = false,
  customErrorMessage
) => {
  if (ex.response) {
    if (fileRequest) {
      if (history && ex.response.status === 401) {
        localStorage.removeItem(tokenKeyName);
        history.push(pages.loginPage.url);
        // console.log("should return to login");
        toast.error("401 Unauthorized. Please try signing in again.");
      } else {
        if (customErrorMessage) {
          toast.error(customErrorMessage);
        } else {
          toast.error("Error downloading file.");
        }
        return;
      }
    }
    // console.log(ex);
    // console.log("printing ex response");
    // console.log(ex.response);
    if (history && ex.response.status === 401) {
      //if we get an unauthorized error from backend, that means our token has expired,
      //so remove it, and send them back to the login screen.
      localStorage.removeItem(tokenKeyName);
      history.push(pages.loginPage.url);
      // console.log("should return to login");
      toast.error("401 Unauthorized. Please try signing in again.");
    } else if (customErrorMessage) {
      toast.error(customErrorMessage);
      return;
    } else if (ex.response.status === 72) {
      toast.warn("Route Issue" + ex.response.data, { autoClose: 10000 });
    } else if (ex.response.status === 73) {
      //if ex.response.data is a string, display that
      if (ex.response?.data && typeof ex.response.data === "string") {
        toast.warn("Issue:" + ex.response.data);
      } else {
        //but if it is an object with a message inside, display that
        if (ex.response?.data?.message) {
          toast.warn("Issue:" + ex.response.data.message);
        }
      }
    } else if (ex.response.data) {
      // toast.error(`Api Error: Status Code = ${ex.response.status}`);
      let message = "";

      const { data, status } = ex.response;

      if (data.modelState) {
        let modelStateMessages = [];

        var messageArrays = Object.values(data.modelState);

        messageArrays.forEach((arr) => {
          arr.forEach((msg) => modelStateMessages.push(msg));
        });

        message = "Validation Error(s): " + modelStateMessages.join(" ");
      } else {
        message = `Api Error (${status}): ${data.message ?? data}`; //added for 403 error "you cannot ship to this city and state"
      }

      toast.error(message);
    }
    //no data
    else {
      if (ex.response.status === 404) {
        toast.error("Not Found");
      } else {
        toast.error(`Api Error (${ex.response.status})`);
      }
    }
  } else if (axios.isCancel(ex)) {
    //if the error is from us cancelling unneeded requests, do nothing - that is what we want.
    // console.log("previous call cancelled");
  } else {
    toast.error("An issue occurred.\n" + ex);
  }
};

export default handleApiError;
